export default __webpack_public_path__ + "static/media/AlliedServicesLebenswerkBusinessManagement2.19a6a3f6.png";